
import { PublicationsLastModel } from '../models/PublicationsLastModel.js';
import { PublicationsLastView } from '../views/PublicationsLastView.js';

export class PublicationsLastController {
    constructor() {

        this.model = new PublicationsLastModel();
        this.view = new PublicationsLastView();

        this.model.subscribe(state => this.view.render(state));
    }
}